<div class="container">
  <section class="footer">
    <div class="footer-container">
      <div class="footer-info">
        <div class="footer-info-title">
          BusyFly 2018-{{currentYear}}
        </div>
        <div class="footer-social-networks">
          <a href="https://www.instagram.com/busyfly_sharing/" class="footer-social-item instagram-icon"> </a>
          <a href="https://www.facebook.com/busyflysharing" class="footer-social-item facebook-icon"> </a>
        </div>
      </div>

      <div class="footer-item">
        <div class="footer-link" [routerLink]="['../rental-all']">
          Договор аренды
        </div>
        <div class="footer-link" [routerLink]="['../electric-scooters-rental-agreement']">
          Договор аренды электроснегокатов
        </div>
        <div class="footer-link" [routerLink]="['../privacy-all']">
          Политика конфиденциальности
        </div>
        <div class="footer-link" [routerLink]="['../license-all']">
          Лицензионное соглашение
        </div>
        <div class="footer-link" [routerLink]="['../public-offer-courier']">
          Публичная оферта BusyFly Курьер"
        </div>
        <div class="footer-link" [routerLink]="['../terms-of-use']">
          Правила использования электросамоката
        </div>
        <div class="footer-link" [routerLink]="['../parts']">
          Перечень запчастей для клиентов
        </div>
        <div class="footer-link" [routerLink]="['../payment-information']">
          Правила оплаты и безопасность платежей
        </div>
        <div class="footer-link" [routerLink]="['../driving-rules']">
          Правила вождения
        </div>
        <div class="footer-link" [routerLink]="['../insurance']">
          Условия страхования
        </div>
      </div>
    </div>
  </section>
</div>
